import { isJsonObject } from "../../Core/Json";

/** Terria specific properties */

export function isTerriaFeatureData(data) {
  return data && isJsonObject(data, false) && "type" in data && data.type === "terriaFeatureData";
}